<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 52.84 44.94"
    class="svg-icon"
    :style="{
      fill: fill
    }"
  >
    <path
      d="M960.48,525.81c6.16-7.11,11.48-9.06,17.61-6.67,7.19,2.81,10.45,9.92,8.23,18-2,7.14-6.73,12.25-12.36,16.65-3.8,3-7.77,5.68-11.66,8.52-.91.67-1.69,1.27-2.92.36-6.87-5-14.24-9.44-19.68-16.18-3.24-4-5.41-8.54-5.53-13.84-.14-6.37,3.26-11.47,9-13.5A13.64,13.64,0,0,1,959,523.92C959.42,524.5,959.88,525.06,960.48,525.81Z"
      transform="translate(-934.17 -518.17)"
    />
  </svg>
</template>

<script>
export default {
  name: "IconHeartFilled",
  props: {
    fill: {
      type: String,
      default: "#fe6384"
    }
  }
};
</script>

<style scoped></style>
